import { render, staticRenderFns } from "./WistiaVideoGroupEditor.vue?vue&type=template&id=ab7206f6&"
import script from "./WistiaVideoGroupEditor.vue?vue&type=script&lang=js&"
export * from "./WistiaVideoGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports